import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "מה זה בעצם MOM3NTUM?",
    a: 'זו פלטפורמה טכנולוגית שמעניקה לאוהדים "נתיב מהיר" ומובטח לרכישת כרטיסים במחיר המקורי, לפני שהם נחטפים על ידי ספסרים.',
  },
  {
    q: "איך המחיר נשאר מקורי?",
    a: "אנחנו לא מוכרים כרטיסים ברווח. אנחנו מוכרים גישה. הכרטיס עצמו נרכש תמיד בערך הנקוב שלו (Face Value).",
  },
  {
    q: "זה באמת בלי הגרלות?",
    a: "בדיוק. הגישה שלכם מבוססת על המעורבות שלכם בקהילה ועל מערכת עדיפויות שקופה. מי שפעיל – זוכה.",
  },
  {
    q: "זה עולה כסף?",
    a: "ההרשמה הראשונית היא בחינם. גישה לקמפיינים ספציפיים או שירותי פרימיום עשויה להיות כרוכה בעלות שתמיד תשתלם לכם מול מחירי השוק השחור.",
  },
];

export default function LandingFAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-20 md:py-28" style={{ background: "#121212" }}>
      <div className="max-w-3xl mx-auto px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-bold text-white text-center mb-12"
          style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)" }}
        >
          אתם שואלים, אנחנו עונים
        </motion.h2>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="rounded-2xl overflow-hidden"
              style={{
                border: open === i ? "1.5px solid rgba(215,255,55,0.4)" : "1.5px solid rgba(255,255,255,0.08)",
                background: "#1A1A1A",
                transition: "border-color 0.2s",
              }}
            >
              <button
                className="w-full flex items-center justify-between p-5 text-right cursor-pointer"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="font-bold text-white">{faq.q}</span>
                <ChevronDown
                  className="w-5 h-5 flex-shrink-0 ml-3 transition-transform duration-200"
                  style={{
                    color: "#D7FF37",
                    transform: open === i ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <p
                      className="px-5 pb-5 pt-3 text-base leading-relaxed"
                      style={{
                        color: "#FFFFFF",
                        borderTop: "1px solid rgba(255,255,255,0.08)",
                      }}
                    >
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
